import sectionItemsGridMediaCss from '../css-snippets/section-items-grid-media';

const html = ` 
<style>${sectionItemsGridMediaCss}</style>
<div
  id="items-grid-media-wrapper-unique-id"
  data-id="unique-id"
  class="items-grid-media-wrapper"
  data-attribute="items-grid-media-wrapper"
  data-background-color="#ffffff"
  data-text-color="#000000"
  data-top-padding="true"
  data-bottom-padding="true"
  data-items-per-row-mobile="1"
  data-items-per-row-desktop="2"
  data-video-height="315"
  style="
    --background-color: #ffffff;
    --text-color: #000000;
    --items-per-row-mobile: 1;
    --items-per-row-desktop: 2;
    --video-height: 315px;
  "
>
  <div
    data-attribute="items-grid-media-container"
    class="items-grid-media-container container"
  >
    <div
      class="items-grid-media-header"
      data-attribute="items-grid-media-header"
    >
      <h2 style="text-align: center">
        <strong>Real People. Verified Results.</strong>
      </h2>
      <p style="text-align: center">
        With over 2 million boxes sold in 50+ countries, Lignosus has improved the lives of 600,000+ people. <br /> See what others are saying about their experiences with Lignosus.
      </p>
    </div>
    <div class="items-grid-media-list" data-attribute="items-grid-media-list">
      <div class="items-grid-media-item" data-attribute="items-grid-media-item">
        <div
          class="items-grid-media-item-video"
          data-attribute="items-grid-media-item-video"
        >
          <iframe
            width="560"
            height="315"
            class="items-grid-media-item-video-inner"
            data-attribute="items-grid-media-item-video-inner"
            src="https://www.youtube-nocookie.com/embed/iQvnDIGMmwQ?rel=0"
            title="Lignosus helped to relieve my COPD symptoms"
            frameborder="0"
            allow="
              accelerometer;
              autoplay;
              clipboard-write;
              encrypted-media;
              gyroscope;
              picture-in-picture;
              web-share;
            "
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <div
          class="items-grid-media-item-content"
          data-attribute="items-grid-media-item-content"
        >
          <h2 style="text-align: center">
            <strong>"Lignosus helped to relieve my COPD symptoms"</strong>
          </h2>
        </div>
      </div>
      <div class="items-grid-media-item" data-attribute="items-grid-media-item">
        <div
          class="items-grid-media-item-video"
          data-attribute="items-grid-media-item-video"
        >
          <iframe
            width="560"
            height="315"
            class="items-grid-media-item-video-inner"
            data-attribute="items-grid-media-item-video-inner"
            src="https://www.youtube-nocookie.com/embed/3BYsWRo8WNo?rel=0"
            title="My son stopped relying on asthma puffer"
            frameborder="0"
            allow="
              accelerometer;
              autoplay;
              clipboard-write;
              encrypted-media;
              gyroscope;
              picture-in-picture;
              web-share;
            "
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <div
          class="items-grid-media-item-content"
          data-attribute="items-grid-media-item-content"
        >
          <h2 style="text-align: center">
            <strong>"My son stopped relying on asthma puffer"</strong>
          </h2>
        </div>
      </div>
      <div class="items-grid-media-item" data-attribute="items-grid-media-item">
        <div
          class="items-grid-media-item-video"
          data-attribute="items-grid-media-item-video"
        >
          <iframe
            width="560"
            height="315"
            class="items-grid-media-item-video-inner"
            data-attribute="items-grid-media-item-video-inner"
            src="https://www.youtube-nocookie.com/embed/Ijff02U4Akw?rel=0"
            title="Great product for sinus issues!"
            frameborder="0"
            allow="
              accelerometer;
              autoplay;
              clipboard-write;
              encrypted-media;
              gyroscope;
              picture-in-picture;
              web-share;
            "
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <div
          class="items-grid-media-item-content"
          data-attribute="items-grid-media-item-content"
        >
          <h2 style="text-align: center">
            <strong>"Great product for sinus issues!"</strong>
          </h2>
        </div>
      </div>
      <div class="items-grid-media-item" data-attribute="items-grid-media-item">
        <div
          class="items-grid-media-item-video"
          data-attribute="items-grid-media-item-video"
        >
          <iframe
            width="560"
            height="315"
            class="items-grid-media-item-video-inner"
            data-attribute="items-grid-media-item-video-inner"
            src="https://www.youtube-nocookie.com/embed/HdXPvB0IsyU?rel=0"
            title="Helped with my asthma!"
            frameborder="0"
            allow="
              accelerometer;
              autoplay;
              clipboard-write;
              encrypted-media;
              gyroscope;
              picture-in-picture;
              web-share;
            "
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <div
          class="items-grid-media-item-content"
          data-attribute="items-grid-media-item-content"
        >
          <h2 style="text-align: center">
            <strong>"Helped with my asthma!"</strong>
          </h2>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
